import { render } from "./AdminSidebar.vue?vue&type=template&id=0e56e815&scoped=true"
const script = {}

import "./AdminSidebar.vue?vue&type=style&index=0&id=0e56e815&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e56e815"]])

export default __exports__